import type { Category } from "../api/category";

export const getCategoryCheckLines = (category: Category): string[] => {
  const lines =
    category.checks
      ?.map((check) => check.description?.trim() || check.code?.trim() || check.id?.trim())
      .filter((line): line is string => Boolean(line)) ?? [];

  return lines.length ? lines : ["—"];
};
